
import {Component, Prop, Vue} from "vue-property-decorator";
import vModal from "@/components/vModal.vue";
import {mapState} from "vuex";
import {ExitSurveyDto} from "@/models/Subscriptions/ExitSurveyDto";
import {CancellationReason} from "@/models/Subscriptions/CancellationReason";
import {LocalizationState} from "@/store/modules/LocalizationModule";
import {AccountState} from "@/store/modules/AccountModule";

@Component({
  components: {
    vModal,
  },
  computed: {
    ...mapState({
      localizationState: (state: any) => state.LocalizationModule,
      accountState: (state: any) => state.AccountModule,
    }),
  },
})
export default class vCancellationSurvey extends Vue {
  @Prop() showSurveyModal!: boolean;

  localizationState: LocalizationState;
  accountState: AccountState;
  reasons: string[] = [];

  exitSurvey: ExitSurveyDto = {
    userId: this.$store.getters.getUserDetails.userId,
    subscriptionPackageId: 0,
    restaurantId: 0,
    cancellationReason: CancellationReason.Other,
    lackingFeatureDescription: "",
    lackingCustomerSupportDescription: "",
    otherReasonsDescription: "",
    wouldAcceptSpecialOffer: false
  };

  get translations() {
    return this.localizationState.translations;
  }

  getCancellationReason(): CancellationReason {
    let reason = CancellationReason.Other;
    if (this.reasons.includes('no_longer_need')) {
      reason |= CancellationReason.NoLongerNeeded;
    }

    if (this.reasons.includes('too_expensive')) {
      reason |= CancellationReason.TooExpensive;
    }

    if (this.reasons.includes('concerns_with_label')) {
      reason |= CancellationReason.AccuracyConcerns;
    }

    if (this.reasons.includes('switching_service')) {
      reason |= CancellationReason.SwitchingPlatforms;
    }

    if (this.reasons.includes('lack_of_features')) {
      reason |= CancellationReason.LackingFeatures;
    }

    if (this.reasons.includes('issues_with_support')) {
      reason |= CancellationReason.CustomerSupportIssues;
    }

    if (this.reasons.includes('other_feedback')) {
      reason |= CancellationReason.Other;
    }

    return reason;
  }

  submitSurvey() {
    if (this.reasons.length === 0) {
      this.$snotify.error(
        this.translations.get('select_reason')
      );
      return;
    }

    this.exitSurvey = {
      userId: this.accountState.userDetails.userId,
      subscriptionPackageId: this.accountState.userDetails.subscriptionPackageId,
      restaurantId: this.accountState.userDetails.restaurantId,
      cancellationReason: this.getCancellationReason(),
      lackingFeatureDescription: this.exitSurvey.lackingFeatureDescription,
      lackingCustomerSupportDescription: this.exitSurvey.lackingCustomerSupportDescription,
      otherReasonsDescription: this.exitSurvey.otherReasonsDescription,
      wouldAcceptSpecialOffer: this.exitSurvey.wouldAcceptSpecialOffer
    };

    this.$emit('survey-submitted', this.exitSurvey);
    this.closeSurveyModal();
  }

  closeSurveyModal() {
    this.$emit("on-cancel");
  }
}
   